import React from "react";

export const FastForwardDefault = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="54" height="54" rx="27" stroke="#D9D9DE" strokeWidth="2"/>
    <g clipPath="url(#clip0_3827_54)">
      <path d="M31.4234 18.0203C30.8797 17.5 30.0781 17.3547 29.3891 17.65C28.7 17.9453 28.25 18.625 28.25 19.375V25.7641L20.1734 18.025C19.6297 17.5 18.8281 17.3547 18.1391 17.65C17.45 17.9453 17 18.625 17 19.375V36.625C17 37.375 17.45 38.0547 18.1391 38.35C18.8281 38.6453 19.6297 38.5 20.1734 37.9797L28.25 30.236V36.625C28.25 37.375 28.7 38.0547 29.3891 38.35C30.0781 38.6453 30.8797 38.5 31.4234 37.9797L40.4234 29.3547C40.7938 29.0032 41 28.511 41 28C41 27.4891 40.7891 27.0016 40.4234 26.6453L31.4234 18.0203Z" fill="#212121"/>
    </g>
    <defs>
      <clipPath id="clip0_3827_54">
        <rect width="24" height="24" fill="white" transform="translate(16 16)"/>
      </clipPath>
    </defs>
  </svg>
);

export const FastForwardHover = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="28" fill="#212121"/>
    <g clipPath="url(#clip0_3827_56)">
      <path d="M31.4234 18.0203C30.8797 17.5 30.0781 17.3547 29.3891 17.65C28.7 17.9453 28.25 18.625 28.25 19.375V25.764L20.1734 18.025C19.6297 17.5 18.8281 17.3547 18.1391 17.65C17.45 17.9453 17 18.625 17 19.375V36.625C17 37.375 17.45 38.0547 18.1391 38.35C18.8281 38.6453 19.6297 38.5 20.1734 37.9797L28.25 30.2359V36.625C28.25 37.375 28.7 38.0547 29.3891 38.35C30.0781 38.6453 30.8797 38.5 31.4234 37.9797L40.4234 29.3547C40.7938 29.0031 41 28.5109 41 28C41 27.489 40.7891 27.0015 40.4234 26.6453L31.4234 18.0203Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_3827_56">
        <rect width="24" height="24" fill="white" transform="translate(16 16)"/>
      </clipPath>
    </defs>
  </svg>
);
